export default {
  download: 'Tải tài liệu',
  safety: 'Tải tài liệu <br/>Giải pháp quản lý an toàn công trường xây dựng',
  assets: 'Tải tài liệu <br/>Phân tích vị trí tồn kho kho vận',
  medical: 'Tải tài liệu <br/>Theo dõi thiết bị y tế bệnh viện',
  process: 'Tải tài liệu <br/>Giám sát quy trình sản xuất theo thời gian thực',
  visitor: 'Tải tài liệu <br/>Phân tích lộ trình khách tham quan',

  description: 'Chúng tôi sẽ gửi tài liệu qua email cho bạn.',

  form: {
    emailPlaceholder: 'name@company.com',
    policy: {
      info: 'Bằng cách cung cấp thông tin, bạn đồng ý với ',
      link: 'Chính sách bảo mật của Orbro',
      agree: '.',
      check: '[Bắt buộc]',
    },
  },

  cancel: 'Hủy',
  submit: 'Tải xuống',

  send: 'Tài liệu đã được gửi đến<br/>email của bạn.',
  newsletter:
    'Nếu bạn muốn nhận bản tin từ Orbro, hãy điền vào biểu mẫu dưới đây! Chúng tôi sẽ gửi cho bạn những tin tức và thông tin mới nhất mỗi tuần qua email.',
  name: 'Họ và tên (bắt buộc)',
  namePlaceholder: 'Nguyễn Văn A',
  team: 'Tên tổ chức (bắt buộc)',
  teamPlaceholder: 'Tên tổ chức / công ty',
  phone: 'Số điện thoại (tùy chọn)',
  phonePlaceholder: '090-1234-5678',
  skip: 'Bỏ qua',
  subscribe: 'Đăng ký',

  ask: 'Bạn có muốn đăng ký nhận bản tin từ Orbro để cập nhật công nghệ và các thông tin khác không?',
  thanks: 'Cảm ơn bạn đã đăng ký.',
  thanksMore:
    'Cảm ơn bạn đã đăng ký nhận bản tin từ Orbro! Chúng tôi sẽ gửi cho bạn những tin tức và thông tin mới nhất qua email. Hãy đồng hành cùng Orbro để nhận thêm kiến thức và thông tin hữu ích.',
  done: 'Xác nhận',
};
